import React from 'react'
import PageNotice from './PageNotice'
import { PATH } from '../../../app/routes'

const ConnectorRequired = () => (
    <PageNotice
        title="No connector selected"
        hint="Open a connector from My Products to continue."
        linkTo={PATH.MY_PRODUCTS}
        linkLabel="Go to My Products"
    />
)

export default ConnectorRequired
